
// ThemeContext.js

import React, { createContext, useState, useContext } from 'react';
import { lightTheme, darkTheme } from '../themes.js'; // Importe os temas do arquivo themes.js

const ThemeContext = createContext();

export const ThemeProvider = ({ children }) => {
  const [theme, setTheme] = useState('light');

  const toggleTheme = () => {
    setTheme(theme === 'light' ? 'dark' : 'light');
  };

  const themeMode = theme === 'light' ? lightTheme : darkTheme; // Use os temas importados

  return (
    <ThemeContext.Provider value={{ theme: themeMode, toggleTheme }}>
      {children}
    </ThemeContext.Provider>
  );
};

export const useTheme = () => useContext(ThemeContext);